import React from "react";
import { useNavigate } from "react-router-dom";
import "./EmailAlreadyVerified.css";

const EmailAlreadyVerified = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/");
  };

  return (
    <div className="email-already-verified-container">
      <div className="email-already-verified-card">
        <h2 className="email-already-verified-title">
          Email Already Verified
        </h2>
        <p className="email-already-verified-text">
          Your email has already been verified. You can now log in to your account.
        </p>
        <div className="email-already-verified-button-wrapper">
          <button
            className="email-already-verified-button"
            onClick={handleGoToLogin}
          >
            Go to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailAlreadyVerified;

